<script>
import NavBar from "@/components/nav-bar";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";

/**
 * Layout horizontal — topbar fixa + conteudo + footer.
 * Identico ao tema Velzon (sem sidebar).
 */
export default {
  components: { NavBar, RightBar, Footer },
  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onRoutechange(ele) {
      this.initActiveMenu(ele.path);
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#navbar-nav")) {
          const a = document
            .querySelector("#navbar-nav")
            .querySelector('[href="' + ele + '"]');

          if (a) {
            a.classList.add("active");
            const parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add("active");
              parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
              if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                  parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      }, 300);
    },
  },
  mounted() {
    if (document.querySelectorAll(".navbar-nav .collapse")) {
      const collapses = document.querySelectorAll(".navbar-nav .collapse");
      collapses.forEach((collapse) => {
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation();
          const closestCollapse = collapse.parentElement.closest(".collapse");
          if (closestCollapse) {
            const siblingCollapses = closestCollapse.querySelectorAll(".collapse");
            siblingCollapses.forEach((sc) => {
              if (sc.classList.contains("show")) {
                sc.classList.remove("show");
                sc.parentElement.firstChild.setAttribute("aria-expanded", "false");
              }
            });
          }
        });
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation();
          const childCollapses = collapse.querySelectorAll(".collapse");
          childCollapses.forEach((cc) => {
            cc.classList.remove("show");
            cc.parentElement.firstChild.setAttribute("aria-expanded", "false");
          });
        });
      });
    }
  },
};
</script>

<template>
  <div>
    <div id="layout-wrapper">
      <NavBar />

      <div class="main-content">
        <div class="page-content" style="margin-top: 0 !important">
          <BContainer fluid>
            <slot />
          </BContainer>
        </div>
        <Footer />
      </div>
      <RightBar />
    </div>
  </div>
</template>
